import React, { Component } from 'react'
import EventsHtml from './EventsHtml'

class Events extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messages: [],
      textField: '',
    }
    this.messageBoxCSS = {
      maxHeight: '200px',
      minHeight: '200px',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      maxWidth: '800px',
      background: '#eee',
      margin: '0 auto',
    }
  }
  /*
  onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit
onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave
onMouseMove onMouseOut onMouseOver onMouseUp
*/
  messageUpdate = newMessage => {
    this.setState((state, props) => ({
      messages: [...state.messages, newMessage],
    }))
  }

  blurThis = () => {
    this.messageUpdate('onBlur')
  }
  changeThis = e => {
    this.setState({ textField: e.target.value })
  }
  copyThis = () => {
    this.messageUpdate('onCopy')
  }
  cutThis = () => {
    this.messageUpdate('onCut')
  }
  focusThis = () => {
    this.messageUpdate('onFocus')
  }
  inputThis = () => {
    this.messageUpdate('onInput')
  }
  invalidThis = () => {
    this.messageUpdate('onInvalid')
  }
  pasteThis = () => {
    this.messageUpdate('onPaste')
  }
  keyDown = () => {
    this.messageUpdate('onKeyDown')
  }
  keyUp = () => {
    this.messageUpdate('onKeyUp')
  }
  keyPress = () => {
    this.messageUpdate('onKeyPress')
  }

  render() {
    return (
      <EventsHtml
        props={this.props}
        keyUp={this.keyUp}
        keyDown={this.keyDown}
        pasteThis={this.pasteThis}
        messageUpdate={this.messageUpdate}
        blurThis={this.blurThis}
        changeThis={this.changeThis}
        messages={this.state.messages}
        cutThis={this.cutThis}
        copyThis={this.copyThis}
        focusThis={this.focusThis}
        inputThis={this.inputThis}
        invalidThis={this.invalidThis}
        keyPress={this.keyPress}
        messageBoxCSS={this.messageBoxCSS}
      />
    )
  }
}

export default Events
